<template>
  <div id="edit">
<v-app>
    <v-container fluid grid-list-lg>
      <v-flex justify-center xs12 sm12 md12>

<form>

      <v-layout justify-center row wrap>
      <v-flex xs4>
      <span class="headline">Editing {{did}}</span>
        <v-select
        v-model="company"
        :items="companies"
        item-text="company"
        label="Company"
        solo
        >
        </v-select>
      </v-flex>
            </v-layout>
      <v-layout justify-center row wrap>
      <v-flex xs4>
        <v-select
          v-model="devicetype"
          :items="devices"
          item-text="devicetype"
          label="Device Type"
          solo
        >
        </v-select>
      </v-flex>
      </v-layout>

<v-layout justify-center row wrap>
      <v-flex xs2>
      <v-text-field
      v-model="did"
      :mask="'(###) ###-####'"
      return-masked-value
      :error-messages="errors.collect('did')"
      label="DID"
      data-vv-name="did"
      disabled
      ></v-text-field>
      </v-flex>

      <v-flex xs2>
      <v-text-field
      v-model="tempdid"
      :mask="'(###) ###-####'"
      return-masked-value
      :error-messages="errors.collect('tempdid')"
      label="Temporary DID"
      data-vv-name="tempdid"
      ></v-text-field>
      </v-flex></v-layout>





    <v-layout justify-center row wrap>
      <v-flex xs2>
       <v-checkbox
        v-validate="'required'"
        v-model="e911"
        :error-messages="errors.collect('checkbox')"
        label="E911"
        data-vv-name="e911"
        type="e911"
        required
       ></v-checkbox>
      </v-flex>

      <v-flex xs2>
      <v-text-field
      :disabled="!e911"
      v-validate="'required|max:140'"
      v-model="e911address"
      :counter="140"
      :error-messages="errors.collect('e911address')"
      label="E911 Address"
      data-vv-name="e911address"
      required
    ></v-text-field>
    </v-flex>
    </v-layout>

<v-layout justify-center row wrap>
      <v-flex xs1>
      <v-text-field
      v-validate="'required|max:4'"
      v-model="extension"
      :mask="'####'"
      :counter="4"
      :error-messages="errors.collect('extension')"
      label="Extension"
      data-vv-name="extension"
      required
    ></v-text-field>
    </v-flex>
     <v-flex xs3>
      <v-text-field
      v-validate="'required|max:140'"
      v-model="user"
      :counter="20"
      :error-messages="errors.collect('user')"
      label= "User"
      data-vv-name="user"
      required
    ></v-text-field>
    </v-flex>
    </v-layout>

    <v-layout justify-center row wrap>
      <v-flex xs4>
      <v-text-field
      v-validate="'required|max:140'"
      v-model="notes"
      :counter="140"
      :error-messages="errors.collect('notes')"
      label="Notes"
      data-vv-name="notes"
      required
    ></v-text-field>
      <v-btn color="blue lighten-1" v-on:click="updateItem">Update</v-btn>
      <v-btn color="red lighten-1" v-on:click="deleteDID" >Delete</v-btn>
      <v-btn to="/" >Cancel</v-btn>
    </v-flex>
    </v-layout>
    </form>



    <!--<h3>Edit</h3>
    <div class="row">
      <form @submit.prevent="updateItem" class="col s12">
        <div class="row">
          <div class="input-field col s12">
            <input disabled type="text" v-model="did"
            required>
          </div>
        </div>
        <div class="row">
          <div class="input-field col s12">
            <input type="text" v-model="name"
            required>
          </div>
        </div>
        <div class="row">
          <div class="input-field col s12">
            <input type="text" v-model="dept"
            required>
          </div>
    </div>
        <div class="row">
          <div class="input-field col s12">
            <input type="text" v-model="position"
            required>
          </div>
        </div>
        <button type="submit" class="btn">Submit</button>
        <router-link to="/" class="btn
        grey">Cancel</router-link>

      </form>
    </div>-->
    </v-flex>
    </v-container>
    </v-app>
      </div>
</template>

<script>
import db from './firebaseinit'
export default {
  name: 'edit',
  data () {
    return {
      companies: [],
      devices: [],
      company: null,
      devicetype: null,
      did: null,
      tempdid: null,
      e911: false,
      e911address: null,
      extension: null,
      notes: null,
      user: null,
    }
  },
  created () {
    db.collection("companies")
      .orderBy("company")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            'company': doc.data().company
          };
          this.companies.push(data);
        });
      });
      db.collection("devices")
      .orderBy("devicetype")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            'devicetype': doc.data().devicetype
          };
          this.devices.push(data);
        });
      });
  },
  beforeRouteEnter(to, from, next) {
    db.collection('inventory').where('did',
    '==', to.params.did).get()
    .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        next(vm => {
          vm.company = doc.data().company
          vm.devicetype = doc.data().devicetype
          vm.did = doc.data().did
          vm.tempdid = doc.data().tempdid
          vm.e911 = doc.data().e911
          vm.e911address = doc.data().e911address
          vm.extension = doc.data().extension
          vm.notes = doc.data().notes
          vm.user = doc.data().user
        })
      })
    })
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
      db.collection('inventory').where('did',
      '==', vm.did).get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.company = doc.data().company
          this.devicetype = doc.data().devicetype
          this.did = doc.data().did
          this.tempdid = doc.data().tempdid
          this.e911 = doc.data().e911
          this.e911address = doc.data().e911address
          this.extension = doc.data().extension
          this.notes = doc.data().notes
          this.user = doc.data().user
        })
      })
    },
    updateItem () {
db.collection('inventory').where('did', '==',
      this.did).get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          doc.ref.update({
            company: this.company,
            devicetype: this.devicetype,
            did: this.did,
            tempdid: this.tempdid,
            e911: this.e911,
            e911address: this.e911address,
            extension: this.extension,
            notes: this.notes,
            user: this.user,
          })
      this.$router.push('/')
})
      })
    },
    deleteDID () {
      if(confirm('Are you sure?')) {
      db.collection('inventory').where('did', '==',
      this.$route.params.did).get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          doc.ref.delete()
          this.$router.push('/')
        })
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Edit.vue